<div>
    <ng-container #dynamicContainer></ng-container>
</div>
